import { Component } from "react"

class GitHubId extends Component{
    constructor(props){
        super(props)
        this.name = "GitHub ID"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length > 39){
                callbackDialog("エラー",this.name + "は39文字以内にしてください。")
                return false
            }
            /*if(!/^[a-zA-Z0-9-]{1,39}$/.test(this.props)){
                callbackDialog("エラー",this.name + "の形式ではありません。")
                return false
            }*/
        }
        return true
    }
}

export default GitHubId;